// IndexedDB helper for offline storage
const DB_NAME = 'VoterAppDB';
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = e => {
      const db = e.target.result;
      // Store for pending enrollments (offline)
      if (!db.objectStoreNames.contains('pendingVoters')) {
        db.createObjectStore('pendingVoters', { keyPath: 'localId', autoIncrement: true });
      }
      // Store for cached voter data
      if (!db.objectStoreNames.contains('cachedVoters')) {
        db.createObjectStore('cachedVoters', { keyPath: 'id' });
      }
      // Store for cached stats
      if (!db.objectStoreNames.contains('cachedStats')) {
        db.createObjectStore('cachedStats', { keyPath: 'key' });
      }
    };
    req.onsuccess = e => resolve(e.target.result);
    req.onerror = () => reject(req.error);
  });
}

// Save pending voter (offline enrollment)
export async function savePendingVoter(voterData) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingVoters', 'readwrite');
    const store = tx.objectStore('pendingVoters');
    const req = store.add({ ...voterData, savedAt: new Date().toISOString(), synced: false });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

// Get all pending voters
export async function getPendingVoters() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingVoters', 'readonly');
    const store = tx.objectStore('pendingVoters');
    const req = store.getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

// Delete pending voter after sync
export async function deletePendingVoter(localId) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingVoters', 'readwrite');
    const store = tx.objectStore('pendingVoters');
    const req = store.delete(localId);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

// Cache voters list
export async function cacheVoters(voters) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('cachedVoters', 'readwrite');
    const store = tx.objectStore('cachedVoters');
    store.clear();
    voters.forEach(v => store.put(v));
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// Get cached voters
export async function getCachedVoters() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('cachedVoters', 'readonly');
    const req = tx.objectStore('cachedVoters').getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

// Cache stats
export async function cacheStats(stats) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('cachedStats', 'readwrite');
    const store = tx.objectStore('cachedStats');
    store.put({ key: 'summary', ...stats });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// Get cached stats
export async function getCachedStats() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('cachedStats', 'readonly');
    const req = tx.objectStore('cachedStats').get('summary');
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
}

// Check if online
export const isOnline = () => navigator.onLine;